interface StoryQueryArgs {
  isAdminLayout: boolean;
}

export const storyQuery = ({ isAdminLayout }: StoryQueryArgs) => `
    author {
        id
        avatar {
            averageColor
            externalId
            externalType
            id
            originalFilename
            rightholder
            status
            statusCopyrightId
            thumb
            url
        }
        screenName
    }
    authorId
    cardsCount
    channelId
    feedFollowedStatus
    id
    image {
        averageColor
        id
        originalFilename
        rightholder
        status
        statusCopyrightId
        thumb
        url
    }
    imageId
    isReadOnly
    localeId
    pinned
    pinned2
    pinned3
    pinned4
    pinned5
    position
    settings {
        access
        allowAccessToEditorLimited
        allowAccessToReader
        allowCardReactions
        allowComments
        allowCardMentions
        allowSharing
        autoNotification {
            enabled
            titleDefault
            titlePrefix
            messageDefault
        }
        cardStyles {
            article {
              teaserStyle
            }
            backgroundColor
        }
        cardOrder
        displayItemUpdatedTime
        feedFollowBehavior
        highlightingComments
        horizontalDisplayView {
            position
        }
        includeInMixTab
        includeInMixTab2
        includeInMixTab3
        includeInMixTab4
        includeInMixTab5
        includeInNewsFeed
        includeInWebappNewsFeed
        section
        shouldRestrictDuplicateUrlOfCardsInTimeFrame
        shouldSyncItemPositionsOnConnectedStories
        shouldUpdatePostedTimeByComments
        showAllAuthors
        cardLimit
    }
    externalTags: organisationTags(filters: {types: [EXTERNAL]}) { id name type }
    externalStatusTags: organisationTags(filters: {types: [EXTERNAL_STATUS]}) { id name type }
    ${
      isAdminLayout
        ? `internalTags: organisationTags(filters: {types: [INTERNAL]}) { id name type }`
        : ''
    }
    ${isAdminLayout ? `sources { channel { id name subdomain } story { id title } }` : ''}
    ${
      isAdminLayout
        ? `writeAccess { userTags { id name type } users { id screenName email avatar { url } } }`
        : ''
    }
    status
    subscriptionStatus
    subtitle
    title
    type
`;
